import React, { useState, useEffect } from "react";
import caprimLogo from "../../assets/images/brand/Imagotipo-horizontal.png";

// Duracion del preloader. Ajustada para que el logo entre, se
// mantenga completo un momento y los arcos alcancen a barrer.
const DURACION_MS = 2300;

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, DURACION_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    isLoading && (
      <div className="preloader">
        <span className="preloader-arco preloader-arco--sup" />
        <span className="preloader-arco preloader-arco--inf" />
        <span className="preloader-linea preloader-linea--sup" />
        <span className="preloader-linea preloader-linea--inf" />
        <div className="loading-container">
          <img className="preloader-logo" src={caprimLogo} alt="Caprim" />
        </div>
      </div>
    )
  );
};
export default Preloader;
